import { Stack } from '@mui/material';
import styled from 'styled-components';

export const Container = styled(Stack).attrs({
  spacing: 2.5,
})`
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  margin-top: 38px;
`;
